import * as Actions from '@/store/actions/types';
const DEFAULT = {};
export default (state = DEFAULT, action) => {
    switch (action.type) {
        case Actions.STORE_ALL_ATTRIBUTES: {
            const { collectionName, attributes } = action.payload;
            return Object.assign(Object.assign({}, state), { [collectionName]: [...attributes] });
        }
        default:
            return state;
    }
};
